import React from "react";
const IconClickAndCollect = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 20" {...props}>
    <path
      d="M7.807 6.39c0-2.061 1.293-3.39 2.889-3.39 1.595 0 2.889 1.329 2.889 3.389m2.167 7.081-4.087-1.828 1.843 4.445m2.244-2.617 2.166.97-2.438 1.06-1.064 2.5-.908-1.913m2.244-2.617c.242-2.442.434-4.181.722-7.081H4.918l.963 9.698h7.627"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconClickAndCollect;
